function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";

import "../assets/css/polifont.css";

var Icon = function Icon(props) {
  var className = props.className,
      cssModule = props.cssModule,
      hidden = props.hidden,
      widths = props.widths,
      invalid = props.invalid,
      valid = props.valid,
      Tag = props.tag,
      check = props.check,
      size = props.size,
      style = props.style,
      htmlFor = props.for,
      attributes = _objectWithoutProperties(props, ["className", "cssModule", "hidden", "widths", "invalid", "valid", "tag", "check", "size", "style", "for"]);

  var classes = [invalid ? " icon-invalid" : " ", valid ? " icon-valid" : " "];

  var fashion = null;

  if (props.color) {
    fashion = Object.assign({}, fashion, { color: props.color });
  }
  if (props.background) {
    fashion = Object.assign({}, fashion, { background: props.background, WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent" });
  }
  if (props.size) {
    fashion = Object.assign({}, fashion, { fontSize: props.size + "px" });
  }
  if (props.position) {
    fashion = Object.assign({}, fashion, { position: props.position });
  }
  if (props.top) {
    fashion = Object.assign({}, fashion, { top: props.top });
  }
  if (props.right) {
    fashion = Object.assign({}, fashion, { right: props.right });
  }
  if (props.left) {
    fashion = Object.assign({}, fashion, { left: props.left });
  }
  if (props.cursor) {
    fashion = Object.assign({}, fashion, { cursor: props.cursor });
  }

  return React.createElement(
    "i",
    {
      id: props.id,
      className: props.icon + classes.join(""),
      onClick: props.onClick,
      style: fashion
    },
    props.iconTitle
  );
};

export default Icon;